import { useEffect } from "react";
import { useMantineColorScheme } from "@mantine/core";

/**
 * Mirrors Mantine's resolved color scheme onto <html> as a `dark`/`light` class
 * so Tailwind's `dark:` variant (configured against `.dark`) can react.
 */
export function useThemeSync() {
  const { colorScheme } = useMantineColorScheme();

  useEffect(() => {
    const root = document.documentElement;
    const resolve = () => {
      if (colorScheme === "auto") {
        return window.matchMedia("(prefers-color-scheme: dark)").matches
          ? "dark"
          : "light";
      }
      return colorScheme;
    };

    const apply = () => {
      const scheme = resolve();
      root.classList.remove("dark", "light");
      root.classList.add(scheme);
    };

    apply();

    if (colorScheme === "auto") {
      const mq = window.matchMedia("(prefers-color-scheme: dark)");
      mq.addEventListener("change", apply);
      return () => mq.removeEventListener("change", apply);
    }
  }, [colorScheme]);
}
